module.exports = __webpack_public_path__ + "static/img/logo.f7d7534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 40